module.exports = __webpack_public_path__ + "img/mehrpunkt.a82879e1.jpg";